import api from '../api/axios';

export const memberLogin = async (data) => {
    const response = await api.post('/auth/login', data);
    return response.data;
};

export const getBuildings = async () => {
    const response = await api.get('/buildings');
    return response.data;
};

export const registerVisitor = async (data) => {
    const response = await api.post('/ticket/visitor', data);
    return response.data;
};

export const getTickets = async (page, limit) => {
    const response = await api.get(`/ticket?page=${page}&limit=${limit}`);
    return response.data;
};

/**
 * Search tickets by plate number.
 * @param {number} page - The page number of result.
 * @param {number} limit - The number of results per page.
 * @param {string} search - The plate number to search.
 * @returns {Object} The result of search.
 */
export const searchTicketsbyPlate = async (page, limit, search) => {
    const response = await api.get(`/ticket/search?page=${page}&limit=${limit}&plate=${search}`);
    return response.data;
};

export const getUserDetails = async () => {
    const response = await api.get('/auth/me');
    return response.data;
};

export const updatePassword = async (data) => {
    const response = await api.post('/auth/update-password', data);
    return response.data;
};

export const sendConfirmationEmail = async (email, ticketId) => {
    const response = await api.post(`/ticket/send-email/${ticketId}`, {email});
    return response.data;
};

export const forgotPassword = async (data) => {
    const response = await api.post('/auth/forgot-password', data);
    return response.data;
};

export const resetPassword = async (data) => {
    const response = await api.post('/auth/reset-password', data);
    return response.data;
};

